import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJcLogoShortSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 32,
	viewBox: "0 0 38 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Frame",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector_141",
			className: "animate-stroke",
			stroke: "#ffb510",
			d: "M25.6459 28.0809L6.89199 28.0897L0.186565 16.6848C0.0643319 16.4762 0 16.2397 0 15.999C0 15.7584 0.0643319 15.5219 0.186565 15.3133L8.78792 0.684813C8.91091 0.476536 9.08741 0.303563 9.29978 0.183225C9.51215 0.0628878 9.75296 -0.00062471 9.99816 -0.000976562H27.35C27.5499 -0.000707226 27.7461 0.0511005 27.9192 0.149238C28.0923 0.247375 28.2361 0.388408 28.3362 0.55824L29.41 2.38524H11.0263C10.8948 2.38524 10.7655 2.41925 10.6516 2.48383C10.5377 2.54841 10.4431 2.64129 10.3773 2.75314L2.93678 15.4089C2.83106 15.5896 2.77543 15.7943 2.77543 16.0027C2.77543 16.2111 2.83106 16.4158 2.93678 16.5965L8.28883 25.6991H27.0982L25.6961 28.0838L25.6459 28.0809Z"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_151",
			className: "animate-stroke",
			stroke: "#ffb510",
			d: "M37.0118 16.6856L28.4104 31.3141C28.2874 31.5223 28.1109 31.6952 27.8985 31.8155C27.6862 31.9359 27.4454 31.9994 27.2002 31.9998H9.972C9.73475 31.9996 9.5017 31.9384 9.29606 31.8222C9.09043 31.706 8.91938 31.5389 8.79997 31.3376L7.78906 29.6166H26.1571C26.2936 29.6168 26.4277 29.5818 26.5461 29.515C26.6645 29.4482 26.7629 29.3521 26.8315 29.2362L34.2646 16.5951C34.3703 16.4144 34.4259 16.2097 34.4259 16.0013C34.4259 15.7929 34.3703 15.5882 34.2646 15.4075L28.9088 6.29975H10.0867L11.4887 3.91504H30.3079L37.0118 15.32C37.1329 15.5279 37.1966 15.7632 37.1966 16.0028C37.1966 16.2423 37.1329 16.4777 37.0118 16.6856ZM19.4831 8.70364L19.4764 15.0713L22.5765 15.0749C22.593 15.0749 22.6092 15.0792 22.6235 15.0873C22.6377 15.0954 22.6496 15.1071 22.6578 15.1211C22.666 15.1351 22.6703 15.151 22.6702 15.1672C22.6702 15.1834 22.6658 15.1993 22.6575 15.2133L17.8757 23.3424C17.8651 23.3597 17.8491 23.3731 17.8301 23.3806C17.811 23.3882 17.79 23.3894 17.7702 23.3842C17.7504 23.3789 17.7328 23.3675 17.7202 23.3516C17.7076 23.3357 17.7006 23.3162 17.7003 23.296L17.7071 16.9292L14.6211 16.9255C14.6046 16.9256 14.5883 16.9214 14.5739 16.9134C14.5596 16.9053 14.5476 16.8937 14.5393 16.8796C14.531 16.8656 14.5267 16.8496 14.5267 16.8334C14.5267 16.8171 14.5311 16.8012 14.5395 16.7871L19.3077 8.65726C19.3183 8.63998 19.3343 8.62657 19.3534 8.61903C19.3724 8.61149 19.3934 8.61023 19.4132 8.61547C19.4331 8.62071 19.4506 8.63215 19.4632 8.64806C19.4758 8.66396 19.4828 8.68349 19.4831 8.70364Z"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_186_668299",
		x1: 7.78906,
		y1: 17.9563,
		x2: 37.1984,
		y2: 17.9563,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: .07,
			stopColor: "#FFB510"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#F48210"
		})]
	}) })]
});
export default SvgJcLogoShortSpinner;
